import React, {Component} from 'react';
import FJFontCategory from './FJFontCategory';
import InlineSVG from "react-inlinesvg";
import FJBoldIcon from '../../../icon/FJBoldIcon.svg';
import FJModernIcon from '../../../icon/FJModernIcon.svg';
import FJTraditionalIcon from '../../../icon/FJTraditionalIcon.svg';
import FJHandwritingIcon from '../../../icon/FJHandwritingIcon.svg';
import FJFunnyIcon from '../../../icon/FJFunnyIcon.svg';
import FJSimpleChineseIcon from '../../../icon/FJSimpleChineseIcon.svg';
import FJTraditionalChineseIcon from '../../../icon/FJTraditionalChineseIcon.svg';
import FJJapaneseIcon from '../../../icon/FJJapaneseIcon.svg';

class FJFontFamilyPanel extends Component {

    _getCategories = () => {
        let fontItems = this.props.fontFamilyList;
        let {activeFontName, categoryActiveCallback, loadingFonts} = this.props;
        return fontItems.map((item, index) => {
            let icon = null;
            switch (item.category) {
                case 'bold':
                    icon = <InlineSVG src={FJBoldIcon} element='div' />;
                    break;
                case 'modern(sans)':
                    icon = <InlineSVG src={FJModernIcon} element='div' />;
                    break;
                case 'traditional(serif)':
                    icon = <InlineSVG src={FJTraditionalIcon} element='div' />;
                    break;
                case 'handwriting':
                    icon = <InlineSVG src={FJHandwritingIcon} element='div' />;
                    break;
                case 'funny':
                    icon = <InlineSVG src={FJFunnyIcon} element='div' />;
                    break;
                case '简体中文':
                    icon = <InlineSVG src={FJSimpleChineseIcon} element='div' />;
                    break;
                case '繁体中文':
                    icon = <InlineSVG src={FJTraditionalChineseIcon} element='div' />;
                    break;
                case '日本語':
                    icon = <InlineSVG src={FJJapaneseIcon} element='div' />;
                    break;
            }
            return (
              <li key={item.category}>
                  <FJFontCategory ref={(ele) => {this[item.category] = ele}}
                                  index={index}
                                  showCallback={categoryActiveCallback}
                                  activeFontName={activeFontName}
                                  loadingFonts={loadingFonts}
                                  dataChange={this.props.dataChange}
                                  icon={icon}
                                  fonts={item.items}/>
              </li>
            );
        });
    };
    _getFontCategoryByName(fontName) {
        if (!fontName) {
            return '';
        }
        let fontData = this.props.fontFamilyList;
        for (let i = 0; i < fontData.length; i++) {
            let items = fontData[i].items;
            for (let j = 0; j < items.length; j++) {
                if (items[j].name.toLowerCase() === fontName.toLowerCase()) {
                    return fontData[i].category;
                }
            }
        }

        return '';
    }

    updateTextCategory = () => {
        let category = this._getFontCategoryByName(this.props.activeFontName);
        if (category) {
            this[category].active(true);
        }
    };
    closeAllCategory = () => {
        let fontItems = this.props.fontFamilyList;
        fontItems.forEach((item) => {
            this[item.category].active(false);
        });
    };

    render() {

        return (
            <div className='c-font-family-panel'>
                <ul>
                    {this._getCategories()}
                </ul>
            </div>
        );
    }
}

export default FJFontFamilyPanel;
